var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 301,
    height: 197,
    viewBox: "0 0 301 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "115.258%",
    x2: "43.761%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "79.99%",
    x2: "47.133%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M270.388 98.517c-.212 54.014-44.233 97.735-98.505 97.735-54.404 0-98.506-43.933-98.506-98.126 0-4.643.323-9.211.95-13.683h-30.81a8.6 8.6 0 0 1 0-17.201h70.708a8.6 8.6 0 0 0 0-17.202H72.558a8.6 8.6 0 0 1 0-17.201h25.784C116.383 12.689 142.645 0 171.882 0c42.4 0 78.543 26.685 92.429 64.114h28.088a8.6 8.6 0 1 1 0 17.201h-43.236a8.6 8.6 0 0 0 0 17.202h21.225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M7.826 67.424h15.652a7.826 7.826 0 1 1 0 15.652H7.826a7.826 7.826 0 1 1 0-15.652z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(116.788 38.528)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#80959D",
    d: "M4.816 0h69.803l37.353 42.923v84.701a4.816 4.816 0 0 1-4.816 4.816H4.816A4.816 4.816 0 0 1 0 127.624V4.816A4.816 4.816 0 0 1 4.816 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.866,
    cy: 24.682,
    r: 5.418,
    fill: "#EB8181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.866,
    cy: 52.374,
    r: 5.418,
    fill: "#EB8181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.866,
    cy: 80.066,
    r: 5.418,
    fill: "#EB8181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.866,
    cy: 107.758,
    r: 5.418,
    fill: "#EB8181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    strokeLinecap: "square",
    strokeWidth: 3,
    d: "M32.358 23.478h31.675M32.358 51.17h31.675M32.358 78.862h31.675M32.358 106.554h31.675"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    strokeLinecap: "square",
    d: "M32.358 30.702h14.748M32.358 57.19h14.748M32.358 84.882h14.748M32.358 112.574h14.748"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.564,
    cy: 109.544,
    r: 28.896,
    fill: "#87D5FA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.504 92.688)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M10.752 7.664C11.544 3.544 15.038.44 19.229.44c4.19 0 7.685 3.104 8.477 7.224h6.446L29.6 21.672H10.442L6.02 7.664h4.732zm7.19 6.668h3.015v-3.14h3.016v-3.14h-3.016V4.914H17.94v3.14h-3.016v3.14h3.016v3.139z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M0 3.612h4.145l7.204 21.672h17.547"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.336,
    cy: 31.396,
    r: 2.5,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.336,
    cy: 31.396,
    r: 2.5,
    fill: "#FFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#80959D",
    d: "M74.154.496v39.4a4.816 4.816 0 0 0 4.816 4.816h32.562"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.8097bf7b85785c4e96cb59aa725c7ab3.svg";
export { ForwardRef as ReactComponent };